<template>
  <vx-card>
    <!-- Head -->
    <div class="flex justify-between items-center">
      <h4>신규 시설물 등록 요청</h4>
      <div class="flex">
        <vs-button class="ml-4" color="secondary" type="border" @click="onClickMoveList">목록</vs-button>
        <vs-button class="ml-4" color="secondary" @click="onClickSave">저장</vs-button>
      </div>
    </div>

    <!-- 기본정보 -->
    <div>
      <p class="title mt-5 mb-5">기본정보</p>

      <div class="w-full grid" style="grid-template-columns: 1fr 1fr 1fr; column-gap: 1.5rem">
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">분야명</div>
          <vs-input class="w-full flex-1" v-model="projectInfo.field_name" placeholder="자동입력" readonly />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">소속명</div>
          <vs-input class="w-full flex-1" v-model="myInfo.department" placeholder="자동입력" readonly />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">부서명</div>
          <vs-input class="w-full flex-1" v-model="myInfo.section" placeholder="자동입력" readonly />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">직책</div>
          <vs-input class="w-full flex-1" v-model="companyInfo.director" placeholder="자동입력" readonly />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">작성자</div>
          <vs-input class="w-full flex-1" v-model="myInfo.name" placeholder="자동입력" readonly />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">작성일</div>
          <date-selector class="w-full flex-1" :value="today" placeholder="자동입력" readonly />
        </div>
      </div>
    </div>

    <!-- 신규 사업장 개요 -->
    <div>
      <p class="title mt-5 mb-5">신규 사업장 개요</p>
      <div class="w-full grid" style="grid-template-columns: 1fr 1fr 1fr; column-gap: 1.5rem">
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">시설물명</div>
          <vs-input class="w-full flex-1" v-model="form.field_name" placeholder="입력필드" />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">담당 주무관</div>
          <vs-input class="w-full flex-1" v-model="form.director_name" placeholder="입력필드" />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">준공일</div>
          <date-selector class="w-full flex-1" v-model="form.be_completed_at" placeholder="날짜선택" />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">사업금액</div>
          <vs-input class="w-full flex-1" v-model="form.deposit_amount" placeholder="입력필드" />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">시설물 위치(주소)</div>
          <vs-input class="w-full flex-1" v-model="form.address" placeholder="입력필드" />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center"></div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">구분</div>
          <vs-select class="w-full" autocomplete v-model="form.cat1" @change="onChangeCat1">
            <vs-select-item v-for="option in cat1List" :key="option.cat1" :text="option.cat1" :value="option.cat1" />
          </vs-select>
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">종류</div>
          <vs-select class="w-full" autocomplete v-model="form.cat2" @change="onChangeCat2">
            <vs-select-item v-for="option in cat2List" :key="option.cat2" :text="option.cat2" :value="option.cat2" />
          </vs-select>
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">세분류</div>
          <vs-select class="w-full" autocomplete v-model="form.cat3" @change="onChangeCat3">
            <vs-select-item v-for="option in cat3List" :key="option.cat3" :text="option.cat3" :value="option.cat3" />
          </vs-select>
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">종별</div>
          <vs-select class="w-full" autocomplete v-model="form.cat4" @change="onChangeCat4">
            <vs-select-item v-for="option in cat4List" :key="option.classification" :text="option.classification" :value="option.id" />
          </vs-select>
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">안전 등급</div>
          <vs-input class="w-full flex-1" v-model="form.safety_grade" placeholder="입력필드" />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">형식</div>
          <vs-input class="w-full flex-1" v-model="form.format" placeholder="입력필드" />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">규모1</div>
          <vs-input class="w-full flex-1" v-model="form.scale1" placeholder="입력필드" />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">규모2</div>
          <vs-input class="w-full flex-1" v-model="form.scale2" placeholder="입력필드" />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">규모3</div>
          <vs-input class="w-full flex-1" v-model="form.scale3" placeholder="입력필드" />
        </div>
      </div>
    </div>

    <!-- 수급업체 정보 -->
    <FieldWorkplaceTable v-model="infoDatas" />
  </vx-card>
</template>

<script>
import moment from "moment";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FieldWorkplaceTable from "./components/FieldWorkplaceTable.vue";

import FileInput from "@/components/custom/FileInput";
import FileUploadModule from "@/views/modules/FileUploadModule";
import FileUploader from "@/components/FileUploader";
import CompanyAddModule from "@/views/_BS/components/CompanyAddModule";
import CompanyUserAuthModule from "@/views/_BS/components/CompanyUserAuthModule";
import SearchNavStartEnd from "@/views/list/components/SearchNavStartEnd";
import DateSelector from "@/components/selector/DateSelector";

export default {
  components: {
    FieldSelectModule,
    FieldWorkplaceTable,

    DateSelector,
    SearchNavStartEnd,
    CompanyUserAuthModule,
    CompanyAddModule,
    FileUploader,
    FileInput,
    FileUploadModule,
  },
  data() {
    return {
      form: {
        field_name: "", // 사업장명
        director_name: "", // 담당 주무관
        be_completed_at: "", // 준공일
        deposit_amount: "", // 사업금액
        address: "", //시설물 위치(주소)

        cat1: "", // 구분
        cat2: "", // 종류
        cat3: "", // 세분류
        cat4: "", // 종별

        safety_grade: "", // 안전등급
        format: "", // 형식
        scale1: "", // 규모1
        scale2: "", // 규모2
        scale3: "", // 규모3
      },

      cat1List: [],
      cat2List: [],
      cat3List: [],
      cat4List: [],
      facility_category_id: "",

      infoDatas: [],
      infoSelected: [],
      expandSelected: [],
    };
  },
  computed: {
    myInfo() {
      return this.$store.state.auth.userInfo;
    },
    companyInfo() {
      return this.$store.state.auth.companyInfo;
    },
    projectInfo() {
      return this.$store.state.project.projectInfo;
    },
    postId() {
      return this.$route.params.postId;
    },
    today() {
      return moment(new Date()).format("YYYY-MM-DD");
    },
  },
  created() {
    this.initBreadcrumb();
  },
  async mounted() {
    await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_OPTIONS", {});
    this.cat1List = this.$store.state.project.fieldFacilityCategoryOptions;

    if (this.postId) this.loadField();
  },
  methods: {
    initBreadcrumb() {
      this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "신규 사업장 등록 요청" }, { title: "시설물", active: true }]);
    },
    async loadField() {
      const postId = this.postId;
      await this.$store.dispatch("project/LOAD_FIELD", { postId });
      const info = this.$store.state.project.fieldInfo;
      this.form = { ...info };

      if (this.form.field_map.length > 0) {
        this.form.field_map = this.form.field_map[0];
      } else {
        this.form.field_map = {};
      }
      if (this.form.field_photo.length > 0) {
        this.form.field_photo = this.form.field_photo[0];
      } else {
        this.form.field_photo = {};
      }
      if (this.form.field_view.length > 0) {
        this.form.field_view = this.form.field_view[0];
      } else {
        this.form.field_view = {};
      }

      if (this.form.companies && this.form.companies.length > 0) {
        const companies = [];
        for (const company of this.form.companies) {
          companies.push(company);
        }

        await this.initMembers();
      }
    },
    onClickSave() {
      const company_ids = [];
      const user_ids = [];
      this.form.company_ids = company_ids;
      this.form.user_ids = user_ids;
      this.form.project_id = this.$route.params.proj_id;

      if (this.postId) {
        // update
        const fieldId = this.postId;
        this.$store
          .dispatch("project/UPDATE_FIELD", {
            field_type: "사업장(용역위탁)",
            fieldId,
            ...this.form,
          })
          .then((/*value*/) => {
            this.$router.back();
          });
      } else {
        // create
        this.$store
          .dispatch("project/CREATE_FIELD", {
            field_type: "사업장(용역위탁)",
            ...this.form,
          })
          .then((/*value*/) => {
            this.$router.back();
          });
      }
    },
    onClickMoveList() {
      this.$router.push({ name: "ep-field-facility-list" });
    },

    async onChangeCat1(data) {
      if (data) {
        await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_OPTIONS", { cat1: data });
        this.cat2List = this.$store.state.project.fieldFacilityCategoryOptions;
      }
    },
    async onChangeCat2(data) {
      if (data) {
        await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_OPTIONS", { cat1: this.form.cat1, cat2: data });
        this.cat3List = this.$store.state.project.fieldFacilityCategoryOptions;
      }
    },
    async onChangeCat3(data) {
      if (data) {
        await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_OPTIONS", { cat1: this.form.cat1, cat2: this.form.cat2, cat3: data });
        this.cat4List = this.$store.state.project.fieldFacilityCategoryOptions;
      }
    },
    onChangeCat4(data) {
      this.form.facility_category_id = data;
    },
  },
};
</script>

<style scoped lang="scss">
.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
  padding-left: 18px;

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    background: #7e72f2;
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0px;
    border-radius: 100%;
  }

  & > span {
    color: #696d71;
  }
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.selectbox::v-deep {
  .input-select::placeholder {
    color: #b5b5b5;
    font-size: 12px !important;
  }
}
</style>
